import React, { Component } from "react";
import { InputType, WidthType } from "./input-const";
import { Input, Button, Radio, Form, Switch, message } from 'antd';
import { RegularExpression } from './input-const';
import NHSelect from '../NHSelect';
import PropTypes from "prop-types";

const { TextArea } = Input;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;

/**
 * 输入控件渲染器
 * 根据属性参数、可以渲染成普通输入控件或封装成FormItem类型输入控件配合表单校验
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-02-05 14:35:56
 * Version: 1.0
 * Modify log:
 * 2018-03-29: 1、增加readOnly属性，控制是否可编辑；
 * 2018-05-28: 1、修改:readOnly属性更为为是否是阅读模式；2、新增disabled属性，控制是否可编辑；
 */
export class NHInputRender extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            feature: '',
            featureParams: {}
        }
    }

    componentWillMount() {
        const feature = this.props.feature;

        if (feature) {
            try {
                //解析参数，如果不是正确的json格式，会抛出异常提示
                let featureParams = JSON.parse(feature);
                this.setState({ feature: feature, featureParams: featureParams });
            } catch (e) {
                message.error('解析控件配置参数出错！');

            }
        }
    }

    componentWillReceiveProps(nextProps) {
        // Should be a controlled component.
        const feature = nextProps.feature;
        try {
            //解析参数，如果不是正确的json格式，会抛出异常提示
            let featureParams = JSON.parse(feature);
            this.setState({ feature: feature, featureParams: featureParams });
        } catch (e) {
            message.error('解析控件配置参数出错！');

        }
    }

    //提供组件的onChange方法
    handleChange = (e) => {
        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }

    //渲染成表单项
    renderFormItem = ({ form, hasFeedback = false, patternTag = '', pDefaultValue = '', pRequired = false, component }) => {
        let { getFieldDecorator } = form;
        let { formLayout, formItemLayout, id, value, label, defaultValue, required, readOnly } = this.props;
        let featureParams = this.state.featureParams;
        let requiredRule = {};

        //构建必填校验规则
        if (required) {
            requiredRule.required = true;
            requiredRule.message = label + '不可为空';
        } else {
            if (pRequired) {
                requiredRule.required = true;
                requiredRule.message = label + '不可为空';
            }
        }

        //处理特殊组件在封装成表单项时的“值”属性名称
        let inputType = featureParams.type;
        let valuePropName = 'value';
        let initialValue;
        initialValue = !value ? (!defaultValue ? pDefaultValue : defaultValue) : value;
        if (InputType.SWITCH == inputType) {
            valuePropName = 'checked';
            initialValue = !value ? false : (value == 'true' || value == true ? true : false);
        } else if (InputType.UPLOAD == inputType) {
            valuePropName = 'fileList';
        }

        //处理布局，只有水平布局时才应用表单项布局
        formItemLayout = formLayout == 'horizontal' ? formItemLayout : null;

        if (patternTag != '') {
            return (
                readOnly ?
                    <FormItem {...formItemLayout}
                        label={label}
                    >
                        <span>{initialValue}</span>
                    </FormItem>
                    :
                    <FormItem {...formItemLayout}
                        label={label}
                        hasFeedback={hasFeedback}
                    >
                        {getFieldDecorator(id, {
                            valuePropName: valuePropName,
                            rules: [
                                { ...requiredRule },
                                { ...RegularExpression[patternTag].rule }
                            ],
                            initialValue: initialValue
                        })(
                            component
                        )}
                    </FormItem>
            );
        } else if (required) {
            return (
                readOnly ?
                    <FormItem {...formItemLayout}
                        label={label}
                    >
                        <span>{initialValue}</span>
                    </FormItem>
                    :
                    <FormItem {...formItemLayout}
                        label={label}
                        hasFeedback={hasFeedback}
                    >
                        {getFieldDecorator(id, {
                            valuePropName: valuePropName,
                            rules: [
                                { ...requiredRule }
                            ],
                            initialValue: initialValue
                        })(
                            component
                        )}
                    </FormItem>
            );
        } else {
            return (
                readOnly ?
                    <FormItem {...formItemLayout}
                        label={label}
                    >
                        <span>{initialValue}</span>
                    </FormItem>
                    :
                    <FormItem {...formItemLayout}
                        label={label}
                        hasFeedback={hasFeedback}
                    >
                        {getFieldDecorator(id, {
                            valuePropName: valuePropName,
                            initialValue: initialValue
                        })(
                            component
                        )}
                    </FormItem>
            );
        }

    }

    //渲染单行输入控件类型
    renderInput = () => {
        let { form, id, value, disabled } = this.props;
        let { widthType, widthStr, patternTag, placeholder, required, defaultValue } = this.state.featureParams;

        let inputComponent = null;
        let otherParams = {}; //动态参数

        //如果是表单项类型，则将id,value,defaultValue交由FormItem处理
        if (!form && id !== undefined && id != '') {
            otherParams.id = id;
        }
        if (!form && value !== undefined && value != '') {
            otherParams.value = value;
        }
        if (!form && defaultValue !== undefined && defaultValue != '') {
            otherParams.defaultValue = defaultValue;
        }

        if (widthType != WidthType.DEFAULT) {
            inputComponent = (
                <Input
                    {...otherParams}
                    disabled={disabled}
                    placeholder={placeholder}
                    style={{ width: widthStr }}
                    onChange={this.handleChange}
                />
            );
        } else {
            inputComponent = (
                <Input
                    {...otherParams}
                    disabled={disabled}
                    placeholder={placeholder}
                    onChange={this.handleChange}
                />
            );
        }

        //是否是表单项
        if (form) {
            return this.renderFormItem({
                form: form, hasFeedback: true, patternTag: patternTag, pDefaultValue: defaultValue,
                pRequired: required, component: inputComponent
            });
        }

        return inputComponent;
    }

    //渲染多行输入控件类型
    renderTextArea = () => {
        let { form, id, value, disabled } = this.props;
        let { widthType, widthStr, patternTag, placeholder, required, defaultValue } = this.state.featureParams;

        let textareaComponent = null;
        let otherParams = {}; //其他参数

        if (!form && id !== undefined && id != '') {
            otherParams.id = id;
        }
        if (!form && value !== undefined && value != '') {
            otherParams.value = value;
        }
        if (!form && defaultValue !== undefined && defaultValue != '') {
            otherParams.defaultValue = defaultValue;
        }

        if (widthType != WidthType.DEFAULT) {
            textareaComponent = (
                <TextArea
                    {...otherParams}
                    disabled={disabled}
                    autosize={{ minRows: 2, maxRows: 6 }}
                    placeholder={placeholder}
                    style={{ width: widthStr }}
                    onChange={this.handleChange}
                />
            );
        } else {
            textareaComponent = (
                <TextArea
                    {...otherParams}
                    disabled={disabled}
                    autosize={{ minRows: 2, maxRows: 6 }}
                    placeholder={placeholder}
                    onChange={this.handleChange}
                />
            );
        }

        //是否是表单项
        if (form) {
            return this.renderFormItem({
                form: form, hasFeedback: true, patternTag: patternTag, pDefaultValue: defaultValue,
                pRequired: required, component: textareaComponent
            });
        }

        return textareaComponent;
    }

    //渲染单选框控件类型
    renderRadio = () => {
        let { form, id, value, disabled } = this.props;
        let { options, required, defaultValue } = this.state.featureParams;

        let otherParams = {}; //其他参数

        if (!form && id !== undefined && id != '') {
            otherParams.name = id;
        }
        if (!form && value !== undefined && value != '') {
            otherParams.value = value;
        }
        if (!form && defaultValue !== undefined && defaultValue != '') {
            otherParams.defaultValue = defaultValue;
        }

        const radioComponent = (
            <RadioGroup
                {...otherParams}
                disabled={disabled}
                options={options}
                onChange={this.handleChange}
            />
        );

        //是否是表单项
        if (form) {
            return this.renderFormItem({ form: form, pDefaultValue: defaultValue, pRequired: required, component: radioComponent });
        }

        return radioComponent;
    }

    //渲染下拉选择器输入控件类型
    renderSelect = () => {
        let { form, id, value, disabled } = this.props;
        let { widthType, widthStr, dataTag, required, defaultValue } = this.state.featureParams;

        let selectComponent = null;
        let otherParams = {}; //其他参数

        if (!form && id !== undefined && id != '') {
            otherParams.id = id;
        }
        if (!form && value !== undefined && value != '') {
            otherParams.value = value;
        }
        if (!form && defaultValue !== undefined && defaultValue != '') {
            otherParams.defaultValue = defaultValue;
        }

        if (widthType != WidthType.DEFAULT) {
            selectComponent = (
                <NHSelect
                    {...otherParams}
                    disabled={disabled}
                    sign={dataTag}
                    style={{ width: widthStr }}
                    onChange={this.handleChange}
                />
            );
        } else {
            selectComponent = (
                <NHSelect
                    {...otherParams}
                    disabled={disabled}
                    sign={dataTag}
                    onChange={this.handleChange}
                />
            );
        }

        //是否是表单项
        if (form) {
            return this.renderFormItem({ form: form, pDefaultValue: defaultValue, pRequired: required, component: selectComponent });
        }

        return selectComponent;
    }

    //渲染开关选择器输入控件类型
    renderSwitch = () => {
        let { form, id, checked, disabled } = this.props;
        let { checkedText, uncheckedText, defaultChecked } = this.state.featureParams;

        //let switchComponent = null;
        let otherParams = {}; //其他参数

        if (!form && id !== undefined && id != '') {
            otherParams.id = id;
        }
        if (!form && checked !== undefined && checked != '') {
            otherParams.checked = checked;
        }
        if (!form && defaultChecked !== undefined && defaultChecked != '') {
            otherParams.defaultChecked = defaultChecked;
        }

        let switchComponent = (
            <Switch
                {...otherParams}
                disabled={disabled}
                checkedChildren={checkedText}
                unCheckedChildren={uncheckedText}
                onChange={this.handleChange} />
        );

        //是否是表单项
        if (form) {
            return this.renderFormItem({ form: form, pDefaultValue: defaultChecked, component: switchComponent });
        }

        return switchComponent;
    }

    render() {

        let feature = this.state.feature;
        let featureParams = this.state.featureParams;
        //初步验证参数
        if (feature === undefined || feature === null || feature == '') {
            return null;
        }

        switch (featureParams.type) {
            case InputType.INPUT:
                return this.renderInput(); //单行输入控件类型
                break;
            case InputType.TEXTAREA:
                return this.renderTextArea(); //多行输入控件类型
                break;
            case InputType.RADIO:
                return this.renderRadio(); //单选框控件类型
                break;
            case InputType.SELECT:
                return this.renderSelect(); //下拉选择器输入控件类型
                break;
            case InputType.SWITCH:
                return this.renderSwitch(); //开关输入控件类型
                break;
        }

        return null;
    }
}

NHInputRender.defaultProps = {
    formLayout: "horizontal", //默认水平布局
    formItemLayout: { //表单项布局
        labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
            md: { span: 7 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 12 },
            md: { span: 10 },
        }
    },
    required: false,
    readOnly: false,
}

NHInputRender.propTypes = {
    id: PropTypes.string, //渲染成表单项时的字段标识
    label: PropTypes.string, //渲染成表单项时的字段名称
    checked: PropTypes.bool, //开关、多选控件类型选中属性
    defaultValue: PropTypes.node, //默认值
    value: PropTypes.node, //初始值
    required: PropTypes.bool, //是否必填
    readOnly: PropTypes.bool, //是否只读
    disabled: PropTypes.bool, //是否禁用
    form: PropTypes.object, //表单对象
    feature: PropTypes.string.isRequired, //输入控件参数字符串
    formLayout: PropTypes.string, //表单布局
    formItemLayout: PropTypes.object, //表单项布局
    onChange: PropTypes.func //输入控件值onChange方法
}

export default NHInputRender;


// WEBPACK FOOTER //
// ./app/components/common/NHInputPicker/render.js